// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__32cvL","approved":"Status_approved__3Yw7l","rejected":"Status_rejected__3IIT7","expired":"Status_expired__1-jK7","label":"Status_label__ZXoh8"};